import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {SatPopoverModule} from '@ncstate/sat-popover';
import {NzTooltipModule} from 'ng-zorro-antd/tooltip';
import {HauliermagicAssistantChatComponent} from 'app/layout/components/hauliermagic-assistant-chat/hauliermagic-assistant-chat.component';

@NgModule({
    declarations: [HauliermagicAssistantChatComponent],
    imports: [CommonModule, FormsModule, FontAwesomeModule, SatPopoverModule, NzTooltipModule],
    exports: [HauliermagicAssistantChatComponent]
})
export class HauliermagicAssistantChatModule {}
